module.exports = __webpack_public_path__ + "img/insert-3.456d74fd.png";